import { AWS, AWSGlobal } from "@/aws-cognito/Init";
import { S3AccessKeyId, S3SecretKey } from "@/aws-cognito/S3Config";
import { Actions, Mutations, APIEndpoints } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule, config } from "vuex-module-decorators";
import { bucketName } from "@/aws-cognito/S3Config";

config.rawError = true;

@Module
export default class UploadFileModule extends VuexModule {
  @Action({ rawError: true })
  async [Actions.UPLOAD_FILE](payload) {
    const s3 = new AWS.S3({
      accessKeyId: S3AccessKeyId,
      secretAccessKey: S3SecretKey,
    });

    await s3
      .upload(payload, {
        partSize: 1000 * 1024 * 1024,
        queueSize: 1,
      })
      .promise();
  }

  @Action({ rawError: true })
  async [Actions.GET_S3_SIGNED_URL](fileKey: string) {
    try {
      const s3 = new AWS.S3({
        accessKeyId: S3AccessKeyId,
        secretAccessKey: S3SecretKey,
      });

      const params = {
        Bucket: bucketName,
        Key: fileKey,
        Expires: 3600,
      };

      return new Promise((resolve, reject) => {
        s3.getSignedUrl("getObject", params, (err, url) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(url);
        });
      });
    } catch (error) {
      console.error("Error generating signed URL:", error);
      throw error;
    }
  }
}
